import axiosInstance from "../lib/axiosInstance";

const UsersModel=class {

    async profile() {
        //axiosInstance.defaults.headers.common['Authorization'] = "Bearer "+localStorage.getItem("access_token");
        return (await axiosInstance.get(`${this.baseUrl}/adminapi/profile`)).data?.data || null;
    }

    async updateProfile(data=[])
    {
        return await axiosInstance.put(`${this.baseUrl}/adminapi/update_profile`,data);
    }

    async updatePass(data=[])
    {
        return await axiosInstance.put(`${this.baseUrl}/adminapi/update_pass`,data);
    }


    async create(data=[])
    {
        return await axiosInstance.post(this.baseUrl,data);
    }

    async detail(id)
    {
        return (await axiosInstance.get(`${this.baseUrl}/${id}`)).data;
    }
    async update(id,data=[])
    {
        return await axiosInstance.put(`${this.baseUrl}/${id}`,data);
    }
    
    async delete(id)
    {
        return await axiosInstance.delete(`${this.baseUrl}/${id}`);
    }



}

export default new UsersModel();